import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Pagination from "../pagination/Pagination";
import TableHeaderCell from "../table-cell/TableHeaderCell";
import { showApiErrorMessages } from "../../helpers";
import { indexStudentNotes } from "../../api/endpoints/supervisors/students";
import { useQuery } from "react-query";
import { useOrderBy } from "../../hooks/useOrderBy";
import { ApiCommonParams } from "../../api/@types/apiTypes";
import NoteModel from "../../api/models/NoteModel";
import { getNoteState } from "../sessions/helper";
import { useParams } from "react-router-dom";
export default function StudentNotes() {
  const LocalBasePath = "page.supervisor.student";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { orderBy, getSortingDirection, handleSetSortingOrder } = useOrderBy();
  const { id } = useParams();
  const [filters, setFilters] = useState<{ [key: string]: any }>({});

  const { data: notes } = useQuery(
    ["studentNotes", id, orderBy, filters],
    () => {
      let apiParams: ApiCommonParams = {
        filters,
        orderBy,
      };
      return indexStudentNotes(id ?? "", apiParams);
    },
    {
      select: (response) => {
        let fetchedNotes: NoteModel[] = [];
        if (response.isSuccess) {
          fetchedNotes = NoteModel.fromApiResponse(response.data);
        } else {
          showApiErrorMessages(response);
        }
        const paginationInfo = response.pagination;
        return { data: fetchedNotes, paginationInfo };
      },
    }
  );
  const updateFilterState = (state: string) => {
    if (!!state) setFilters({ state });
    else setFilters({});
  };
  return (
    <div className="w-full flex flex-col  bg-gray-50 mb-2  min-h-screen   ">
      <div className="w-full py-4 flex px-6 justify-between items-center  bg-white">
        <h2 className="text-gray-900 text-lg leading-8 font-semibold">
          {t("notesList")}
        </h2>
        <div className="flex items-center gap-4">
          <button
            onClick={() => updateFilterState("")}
            className="text-[#306CE4] text-xs "
          >
            {t("all")}
          </button>
          <button
            onClick={() => updateFilterState("passed")}
            className="text-[#306CE4] text-xs "
          >
            {t("passed")}
          </button>
          <button
            onClick={() => updateFilterState("unpassed")}
            className="text-[#306CE4] text-xs "
          >
            {t("unPassed")}
          </button>
        </div>
      </div>
      <div className="flex flex-col justify-between">
        <div className="">
          <div className="w-full h-px bg-gray-200" />
          {notes?.data?.length! > 0 ? (
            <>
              <table
                data-cy="notesTable"
                className="min-w-full divide-y table-fixed  divide-gray-300 "
              >
                <thead className="bg-gray-50">
                  <tr>
                    <TableHeaderCell
                      className="w-[128px] text-justify"
                      sortable={true}
                      sortingDirection={getSortingDirection("session_id")}
                      onClick={handleSetSortingOrder("session_id")}
                    >
                      {t("session")}
                    </TableHeaderCell>
                    <TableHeaderCell className="text-justify">
                      {t("note")}
                    </TableHeaderCell>
                    <TableHeaderCell
                      className="w-[128px] text-justify"
                      sortable={true}
                      sortingDirection={getSortingDirection("state")}
                      onClick={handleSetSortingOrder("state")}
                    >
                      {t("status")}
                    </TableHeaderCell>
                  </tr>
                </thead>
                <tbody>
                  {notes?.data.map((note, index) => {
                    return (
                      <tr
                        key={`NoteInfoTable_${index}_note`}
                        className={" border-t "}
                      >
                        <td className={" px-3 py-3.5  lg:table-cell"}>
                          <h6 className="text-sm text-gray-900">
                            {note?.session?.sessionNumber!}#
                          </h6>
                          <h6 className="text-xs text-gray-500">
                            {note?.created_at?.format("DD/MM/YYYY")}
                          </h6>
                        </td>
                        <td
                          className={"relative py-4 pl-4 sm:pl-6 pr-3 text-sm"}
                        >
                          <div className="font-medium text-gray-500">
                            {note.note}
                          </div>
                        </td>
                        <td
                          className={
                            " px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
                          }
                        >
                          {getNoteState(note?.status!)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          ) : (
            <>
              <div className="flex h-[30vh] justify-center items-end">
                <h1>{t("noresultsfound")}</h1>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
